import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController, NavController } from 'ionic-angular';
import { NoticesProvider } from '../../providers/notices/notices';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-popover',
  template: `
    <ion-list no-lines>
      <button ion-item *ngFor="let option of options" (click)="onClick(option)">{{option.title}}</button>
    </ion-list>
  `
})

export class PopoverPage {

  options = [];
  parentPage = null;

  constructor(public viewCtrl: ViewController, 
    public navCtrl: NavController,
    private translate: TranslateService,
    private noticeProvider: NoticesProvider, 
    private toast: ToastProvider,
    private navParams: NavParams) {
    
    this.parentPage = this.navParams.get("parentPage")
    this.options = this.navParams.get('options');
  }

  onClick(option: any){
    option.handler(this.parentPage);
    this.viewCtrl.dismiss();
  }

}


// WEBPACK FOOTER //
// ./src/pages/popover/popover.ts